import { getMonthName as o } from "@amenitiz/design-system";
const u = ($, a, t, g) => {
  const e = $.getMonth(), s = $.getDate(), r = $.getFullYear(), c = a.getMonth(), h = a.getDate(), l = a.getFullYear(), n = g || window.I18n.locale;
  return r === l ? e === c ? `${s} - ${h} ${o({
    month: e,
    locale: n,
    mode: t
  })} ${r}` : `${s} ${o({
    month: e,
    locale: n,
    mode: t
  })} - ${h} ${o({
    month: c,
    locale: n,
    mode: t
  })} ${r}` : `${s} ${o({
    month: e,
    locale: n,
    mode: t
  })} ${r} - ${h} ${o({
    month: c,
    locale: n,
    mode: t
  })} ${l}`;
};
export {
  u as formatDateRange
};
